import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { IntegerQueryItemDto } from 'src/core/models/query/integer-query-item.dto';
import { QueryEditorBase } from 'src/core/models/query/query-editor-base';
import { GenericLookupTypeService } from 'src/core/services/generic-lookup-type/generic-lookup-type.service';
import { GenericLookupTypeState } from 'src/core/states/generic-lookup-type/generic-lookup-type.state';
import { ConversationCustomerSentiment } from 'src/core/models/generic-lookup-type/conversation/customer-sentiment.glt';
import { OrderHelper } from 'src/core/helpers/order.helper';

@Component({
    selector: 'ca-query-tree-node-customer-sentiment',
    templateUrl: './query-tree-node-customer-sentiment.component.html',
    styleUrls: ['./query-tree-node-customer-sentiment.component.scss'],
    standalone: false
})
export class QueryTreeNodeCustomerSentimentComponent extends QueryEditorBase implements OnInit {
  customerSentimentStatuses$: Observable<GenericLookupDto[]>;
  currentStatus: string;

  payload: IntegerQueryItemDto;

  constructor(private store: Store, private genericLookupService: GenericLookupTypeService, private orderHelper: OrderHelper) {
    super();
  }

  valueChanged() {
    this.node.isDirty = true;
    this.payload.genericLookupCode = this.genericLookupService.findGenericLookupWithId(
      this.payload.value
    )?.code;
  }

  ngOnInit(): void {
    this.payload = this.node.categoryItem.payload as IntegerQueryItemDto;

    let sentimentOrder = [
      'Conversation.CustomerSentiment.VeryNegative',
      'Conversation.CustomerSentiment.Negative',
      'Conversation.CustomerSentiment.Neutral',
      'Conversation.CustomerSentiment.Positive',
      'Conversation.CustomerSentiment.VeryPositive',
    ];

    if (
      this.payload.value != ConversationCustomerSentiment.veryNegative &&
      this.payload.value != ConversationCustomerSentiment.veryPositive
    ) {
      sentimentOrder = sentimentOrder.filter(
        f =>
          f != 'Conversation.CustomerSentiment.VeryNegative' &&
          f != 'Conversation.CustomerSentiment.VeryPositive'
      );
    }

    this.customerSentimentStatuses$ = this.store
      .select(GenericLookupTypeState.getGenericLookups)
      .pipe(map(filterFn => filterFn(ConversationCustomerSentiment)))
      .pipe(map(list => this.orderHelper.getOrderedGenericLookupList(list.filter(item => item.code !== 'Conversation.CustomerSentiment.Unknown'), sentimentOrder)));
      
    this.customerSentimentStatuses$.subscribe((statusList: GenericLookupDto[]) => {
      this.currentStatus = statusList.find(item => item.id === this.payload.value).code;
      this.payload.genericLookupCode = this.currentStatus;
    });

    this.node.validationStatus = true;
  }

  getOptionIcon(code: string) {
    let icon = '';
    if (code?.includes('VeryNegative')) {
      icon = 'fa-regular fa-face-disappointed';
    } else if (code?.includes('Negative')) {
      icon = 'far fa-frown';
    } else if (code?.includes('Neutral')) {
      icon = 'far fa-meh';
    } else if (code?.includes('Positive')) {
      icon = 'far fa-smile';
    } else if (code?.includes('VeryPositive')) {
      icon = 'far fa-smile-beam';
    }
    return icon;
  }

  existVeryPositiveNegative() {
    return (
      this.payload.value == ConversationCustomerSentiment.veryNegative ||
      this.payload.value == ConversationCustomerSentiment.veryPositive
    );
  }
}
